<template>
 <!--<div id="app" :class="bodyClass">
     <div v-if="$route.name ==='login'" class="body-login">
      <router-view/>
    </div>
    <main v-else :class="{active: navStatus}">
      <router-view name="nav"></router-view>
      <router-view/>
    </main> -->
    <router-view/>
</template>

<script>
export default {
  data: () => ({
    // isHome: null
    // bodyClass: 'body-dashboard'
  }),
  computed: {
    bodyClass () {
      const route = this.$route.name
      switch (route) {
        case 'home':
          return 'body-dashboard'

        default:
          return 'body-regular'
      }
    },
    navStatus () {
      return this.$store.state.navStatus
    }
  }
}
</script>

<style lang="scss">

</style>
